export default __webpack_public_path__ + "static/media/close-red.ed56d62b.svg";